export default "__VITE_ASSET__NIuP2zxr__"